import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import WrapperOrders from "../../../components/shared/WrapperContent";
import OrdersContent from "../../../components/orders/content";
import style from "./OrdersAvailableAviation.module.scss";
import cn from "classnames";
import DefaultPaginationNew from "../../../components/shared/DefaultPaginationNew/DefaultPaginationNew";
import { Aviation, Notification, Order } from "../../../services";
import FilterIcon from "../../../components/shared/icons/FilterIcon";
import Loading from "../../../components/shared/Loading/Loading";
import EmptyContent from "../../../components/shared/emptyContent";
import { useSelector } from "react-redux";
import HeaderContentNew from "../../../components/shared/HeaderContentNew/HeaderContentNew";
import { CLIENT_AIR_TABS, withClientAirTabTenderFilter } from "../../../mock";
import OrdersAviationTable from "../../../components/orders-aviation/list/OrdersAviationTable";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAirOrderRealtimeEvents } from "../../../hooks/useAirOrderRealtimeEvents";
import { AIR_ORDER_LIST_REFRESH_TARGETS } from "../../../services/orderRealtimeEvents";
import { useClickOutside } from "../../../hooks/useClickOutside";
import OrdersAviationTableMobile from "../../../components/orders-aviation/list/OrdersAviationTableMobile";
import { useAirOrderLimit } from "../../../hooks/useClientLimits";
import AccessDeniedModal from "../../../components/shared/SubscriptionModal/AccessDeniedModal";
import AviaOrderFilter from "../../../components/orders-new/filter/AviaOrderFilter";
import { useLanguage } from "../../../context/LanguageContext";
import ExportAviationOrders from "../../../components/orders-aviation/list/components/ExportAviationOrders";
import { XIcon } from "lucide-react";
import BulkSelectionBar from "../../../components/shared/BulkSelectionBar";
import { withTenderStatusFilter } from "../../../utils/orderTenderFilter";

const ListsAviationPage = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  useClickOutside(dropdownRef, () => setDropdownOpen(false));
  const { airOrderLimit } = useAirOrderLimit();
  const { currentLanguage } = useLanguage();

  const [orders, setOrders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isDisplayModal, changeDisplayModal] = useState(false);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [limit, setLimit] = useState(10);

  const [isActiveTabTender, setIsActiveTabTender] = useState(false);
  const skipNextTabFetch = useRef(false);
  const ordersRequestIdRef = useRef(0);
  const countsRequestIdRef = useRef(0);

  const [activeTap, setActiveTap] = useState("all");
  const [activeStatuses, setActiveStatuses] = useState([]);
  const [orderCounts, setOrderCounts] = useState({});
  const [notificationsMap, setNotificationsMap] = useState({});

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState(() => {
    const defaultTab = CLIENT_AIR_TABS(t).find(tab => tab.key === "all");
    return {
      key: defaultTab?.key,
      status: defaultTab?.statuses,
      title: defaultTab?.title,
      quantity: 0,
    };
  });

  const [isFilterOpen, setFilterOpen] = useState(false);

  const [countries, setCountries] = useState([]);
  const [countryFrom, setCountryFrom] = useState("");
  const [countryTo, setCountryTo] = useState("");
  const [cityFrom, setCityFrom] = useState("");
  const [cityTo, setCityTo] = useState("");
  const [shippingDate, setShippingDate] = useState([]);
  const [creationDate, setCreationDate] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [senderName, setSenderName] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [unselectedIds, setUnselectedIds] = useState([]);
  const [selectionMode, setSelectionMode] = useState("partial");
  const [selectedOrdersById, setSelectedOrdersById] = useState({});

  const resetSelection = useCallback(() => {
    setSelectionMode("partial");
    setSelectedIds([]);
    setUnselectedIds([]);
    setSelectedOrdersById({});
  }, []);

  const items = useMemo(() => {
    return CLIENT_AIR_TABS(t).map((tab) => ({
      key: tab.key,
      status: tab.statuses,
      title: tab.title,
      isExpiredTender: tab.isExpiredTender,
      quantity: orderCounts[tab.key] || 0,
    }));
  }, [orderCounts, t]);

  const hasActiveFilters = useMemo(() => {
    return !!(
      countryFrom ||
      countryTo ||
      cityFrom ||
      cityTo ||
      (Array.isArray(shippingDate) && shippingDate.length > 0 && shippingDate[0]) ||
      (Array.isArray(creationDate) && creationDate.length > 0 && creationDate[0]) ||
      (Array.isArray(selectedStatus) && selectedStatus.length > 0 && selectedStatus[0]) ||
      selectedCurrency ||
      senderName ||
      recipientName ||
      orderNo ||
      selectedEmployee
    );
  }, [
    countryFrom,
    countryTo,
    cityFrom,
    cityTo,
    shippingDate,
    creationDate,
    selectedStatus,
    selectedCurrency,
    senderName,
    recipientName,
    orderNo,
    selectedEmployee,
  ]);

  const handleReset = () => {
    const emptyOverrides = {
      countryFrom: "",
      countryTo: "",
      cityFrom: "",
      cityTo: "",
      shippingDate: [],
      creationDate: [],
      selectedStatus: [],
      selectedCurrency: "",
      senderName: "",
      recipientName: "",
      orderNo: "",
      selectedEmployee: "",
    };

    setCountryFrom("");
    setCountryTo("");
    setCityFrom("");
    setCityTo("");
    setShippingDate([]);
    setCreationDate([]);
    setSelectedStatus([]);
    setSelectedCurrency("");
    setSenderName("");
    setRecipientName("");
    setOrderNo("");
    setSelectedEmployee("");

    setCurrentPage(1);
    resetSelection();

    getOrderCounts({ ...emptyOverrides, page: 1 });
    getOrders(activeStatuses, activeTap, { ...emptyOverrides, page: 1 });
  };

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  const updateActiveStatus = (item, statuses) => {
    setActiveTap(item.key);
    setActiveStatuses(statuses);
    setActiveStatus(item);
    setCurrentPage(1);
    resetSelection();
  };

  const getOrderCounts = (overrides = {}, key = "") => {
    const requestId = ++countsRequestIdRef.current;
    const resolvedKey = key || activeTap;
    const statusGroups = CLIENT_AIR_TABS(t).map((tab) => ({
      key: tab.key,
      status: tab.statuses,
    }));

    const filterData = buildFilterData(overrides);
    const status = overrides.selectedStatus !== undefined ? overrides.selectedStatus : selectedStatus;

    const params = {
      statusGroups,
      countryIdFrom: filterData.countryIdFrom,
      cityIdFrom: filterData.cityIdFrom,
      countryIdTo: filterData.countryIdTo,
      cityIdTo: filterData.cityIdTo,
      startShippingDate: filterData.startShippingDate,
      endShippingDate: filterData.endShippingDate,
      startCreatedAt: filterData.startCreatedAt,
      endCreatedAt: filterData.endCreatedAt,
      currencies: filterData.currencies,
      orderNo: filterData.orderNo,
      senderName: filterData.senderName,
      recipientName: filterData.recipientName,
      userId: filterData.userId,
    };

    if (overrides.statuses !== undefined) {
      params.statuses = overrides.statuses;
    } else if (Array.isArray(status) && status.length > 0) {
      params.statuses = status.map((s) => s.value);
    }

    const requestParams = Array.isArray(params.statuses)
      ? withTenderStatusFilter(params)
      : params;

    Aviation.getOwnAirOrderQuantity(withClientAirTabTenderFilter(requestParams, resolvedKey, t))
      .then((response) => {
        if (requestId !== countsRequestIdRef.current) return;

        const data = response.data;
        const counts = data.reduce((acc, item) => {
          acc[item.key] = item.count;
          return acc;
        }, {});
        setOrderCounts(counts);
      })
      .catch((error) => {
        if (requestId !== countsRequestIdRef.current) return;
        console.error("Ошибка при получении количества заказов:", error);
      });
  };

  const loadCountries = () => {
    Order.getCountries(currentLanguage)
      .then((response) => {
        setCountries(response.data || []);
      })
      .catch((error) => {
        console.error("Ошибка при загрузке стран:", error);
      });
  };

  const getOrderProps = (key) => {
    return {
      isShowOrderDecision: key === "awaitingExpeditor" || "all" || "unloadingCargo",
      isSuggestPrice: key === "tender",
      isAssignDriver: key === "published",
    };
  };

  const buildFilterData = (overrides = {}) => {
    const country_from = overrides.countryFrom !== undefined ? overrides.countryFrom : countryFrom;
    const country_to = overrides.countryTo !== undefined ? overrides.countryTo : countryTo;
    const city_from = overrides.cityFrom !== undefined ? overrides.cityFrom : cityFrom;
    const city_to = overrides.cityTo !== undefined ? overrides.cityTo : cityTo;
    const shipping_date = overrides.shippingDate !== undefined ? overrides.shippingDate : shippingDate;
    const creation_date = overrides.creationDate !== undefined ? overrides.creationDate : creationDate;
    const status = overrides.selectedStatus !== undefined ? overrides.selectedStatus : selectedStatus;
    const currency = overrides.selectedCurrency !== undefined ? overrides.selectedCurrency : selectedCurrency;
    const sender = overrides.senderName !== undefined ? overrides.senderName : senderName;
    const order_no = overrides.orderNo !== undefined ? overrides.orderNo : orderNo;
    const recipient = overrides.recipientName !== undefined ? overrides.recipientName : recipientName;
    const employee =
      overrides.selectedEmployee !== undefined ? overrides.selectedEmployee : selectedEmployee;
    const selected_ids = overrides.selectedIds !== undefined ? overrides.selectedIds : selectedIds;
    const unselected_ids = overrides.unselectedIds !== undefined ? overrides.unselectedIds : unselectedIds;

    const data = {
      page: overrides.page !== undefined ? overrides.page : currentPage,
      limit: limit,
      statuses: activeStatuses,
      countryIdFrom: country_from?.id || "",
      cityIdFrom: city_from?.id || "",
      countryIdTo: country_to?.id || "",
      cityIdTo: city_to?.id || "",
      startShippingDate:
        Array.isArray(shipping_date) && shipping_date[0]
          ? moment(shipping_date[0]).format("YYYY-MM-DD")
          : "",
      endShippingDate:
        Array.isArray(shipping_date) && shipping_date[1]
          ? moment(shipping_date[1]).format("YYYY-MM-DD")
          : "",
      startCreatedAt:
        Array.isArray(creation_date) && creation_date[0]
          ? moment(creation_date[0]).format("YYYY-MM-DD")
          : "",
      endCreatedAt:
        Array.isArray(creation_date) && creation_date[1]
          ? moment(creation_date[1]).format("YYYY-MM-DD")
          : "",
      orderNo: order_no ? String(order_no) : "",
      senderName: sender || "",
      recipientName: recipient || "",
      userId: employee?.id || "",
      currencies: currency ? [currency.value] : [],
      sort: "createdAt,desc",
      lang: currentLanguage,
      selectedIds: selected_ids,
      unselectedIds: unselected_ids,
    };

    if (overrides.statuses !== undefined) {
      data.statuses = overrides.statuses;
    } else if (Array.isArray(status) && status.length > 0 && activeTap === "all") {
      data.statuses = status.map((s) => s.value);
    }

    return withTenderStatusFilter(data);
  };

  const getOrders = async (statuses = [], key = "", overrides = {}, { silent = false } = {}) => {
    const requestId = ++ordersRequestIdRef.current;
    if (!silent) {
      setLoading(true);
    }

    const resolvedKey = key || activeTap;
    const data = withClientAirTabTenderFilter(
      buildFilterData({ ...overrides, selectedIds: [], unselectedIds: [] }),
      resolvedKey,
      t,
    );
    if (resolvedKey !== "all" && statuses.length > 0) {
      data.statuses = statuses;
    }

    try {
      const { data: response } = await Aviation.getOwnAirOrders(data);
      if (requestId !== ordersRequestIdRef.current) return;

      setOrders(response.rows || []);
      setOrdersTotal(response.total || 0);
    } catch (error) {
      if (requestId !== ordersRequestIdRef.current) return;

      console.log(error);
      if (!silent) {
        setOrders([]);
        setOrdersTotal(0);
      }
    } finally {
      if (requestId === ordersRequestIdRef.current) {
        setLoading(false);
      }
    }
  };

  const triggerForceUpdate = () => {
    getOrders(activeStatuses, activeTap, {}, { silent: true });
    getOrderCounts();
  };

  const handleDownloadExcel = () => {
    const params = withClientAirTabTenderFilter(
      buildFilterData({
        selectedIds: selectionMode === "all" ? [] : selectedIds,
        unselectedIds: selectionMode === "all" ? unselectedIds : [],
      }),
      activeTap,
      t,
    );

    setIsExportLoading(true);

    Aviation.getClientExportAirOrders(params)
      .then((response) => {
        if (response.status === 200) {
          const file = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var downloadElement = document.createElement("a");
          downloadElement.href = URL.createObjectURL(file);
          downloadElement.download = "aviation_orders_export.xlsx";
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
        } else {
          alert(t("ordersListPage.toast.downloadError"));
        }
      })
      .catch((error) => {
        console.error("Error downloading Excel:", error);
        alert(t("ordersListPage.toast.downloadError"));
      })
      .finally(() => {
        setIsExportLoading(false);
      });
  };

  const selectedCount = useMemo(() => {
    if (selectionMode === "all") {
      return Math.max(ordersTotal - unselectedIds.length, 0);
    }

    return selectedIds.length;
  }, [ordersTotal, selectedIds.length, selectionMode, unselectedIds.length]);

  useEffect(() => {
    if (selectionMode !== "partial") return;

    const currentOrdersById = new Map(orders.map((order) => [String(order.id), order]));
    setSelectedOrdersById((previousOrdersById) =>
      selectedIds.reduce((nextOrdersById, orderId) => {
        const key = String(orderId);
        const order = currentOrdersById.get(key) || previousOrdersById[key];
        if (order) nextOrdersById[key] = order;
        return nextOrdersById;
      }, {}),
    );
  }, [orders, selectedIds, selectionMode]);

  const selectedOrdersForCancellation = useMemo(
    () =>
      selectedIds
        .map((orderId) => selectedOrdersById[String(orderId)])
        .filter(Boolean),
    [selectedIds, selectedOrdersById],
  );

  const handleSelectAllOrders = () => {
    if (!ordersTotal) return;

    setSelectionMode("all");
    setSelectedIds([]);
    setUnselectedIds([]);
  };

  const handleChangeLimit = (nextLimit) => {
    resetSelection();
    setLimit(nextLimit);
  };

  // Запрос при смене таба, страницы или лимита
  useEffect(() => {
    loadCountries();
    getOrderCounts();
    if (skipNextTabFetch.current) {
      skipNextTabFetch.current = false;
      return;
    }
    getOrders(activeStatuses, activeTap);
  }, [currentPage, limit, isActiveTabTender, activeTap]);

  useEffect(() => {
    if (!orders) return;

    const fetchNotifications = async () => {
      const updatedMap = {};

      for (const item of orders) {
        try {
          const response = await Notification.getOrderNotificationById(item.id);
          updatedMap[item.id] = response?.data || [];
        } catch (err) {
          console.error("Ошибка при получении уведомлений для заказа:", item.id, err);
          updatedMap[item.id] = [];
        }
      }

      setNotificationsMap(updatedMap);
    };

    if (orders.length > 0) {
      fetchNotifications();
    }
  }, [orders]);

  useAirOrderRealtimeEvents(({ target }) => {
    if (!AIR_ORDER_LIST_REFRESH_TARGETS.has(target)) return;

    getOrders(activeStatuses, activeTap, {}, { silent: true });
    getOrderCounts();
  });

  return (
    <>
      <HeaderContentNew
        title={t('ordersAviaPage.header.title')}
        displayTitle
        practicalTitle={t('ordersAviaPage.header.button-title')}
        practicalTitleTooltip={t('tooltips.createAirFreightOrderHint')}
        onPracticalBtnClick={() => {
          if (user && (user?.role?.isUnlimited || airOrderLimit > 0)) {
            navigate("/aviation/create");
          } else {
            changeDisplayModal(true);
          }
        }}
        isListsAviationPage
      />

      <WrapperOrders>
        <AviaOrderFilter
          isOpen={isFilterOpen}
          onClose={() => setFilterOpen(false)}
          filterValues={{
            countryFrom,
            countryTo,
            cityFrom,
            cityTo,
            shippingDate,
            creationDate,
            selectedStatus,
            selectedCurrency,
            senderName,
            orderNo,
            recipientName,
            selectedEmployee,
          }}
          filterSetters={{
            setCountryFrom,
            setCountryTo,
            setCityFrom,
            setCityTo,
            setShippingDate,
            setCreationDate,
            setSelectedStatus,
            setSelectedCurrency,
            setSenderName,
            setOrderNo,
            setRecipientName,
            setSelectedEmployee,
          }}
          filterMeta={{ countries }}
          statusActive={{ key: activeTap }}
          showEmployeeFilter
          onApply={(overrides) => {
            const allTab = CLIENT_AIR_TABS(t).find((tab) => tab.key === "all");
            const allStatuses = allTab?.statuses || [];
            const filterStatuses = overrides.selectedStatus?.length > 0
              ? overrides.selectedStatus.map((s) => s.value)
              : allStatuses;
            setCurrentPage(1);
            getOrderCounts({ ...overrides, page: 1 }, "all");
            getOrders([], "all", { ...overrides, statuses: filterStatuses, page: 1 });
            resetSelection();
            if (activeTap !== "all") {
              skipNextTabFetch.current = true;
              updateActiveStatus(
                { key: allTab?.key, status: allStatuses, title: allTab?.title, quantity: 0 },
                allStatuses
              );
            }
          }}
        />

        <div className={style.menu}>
          {CLIENT_AIR_TABS(t).map((item) => (
            <button
              type="button"
              key={"desktop-" + item.key}
              className={cn(style.menu_button, "d-flex align-items-center text-nowrap", {
                [style.menu_button_active]: item.key === activeTap,
              })}
              onClick={() => updateActiveStatus(item, item.statuses)}
            >
              {item?.title}
              <span
                className={cn(style.count, {
                  [style.count_active]: item.key === activeTap,
                })}
              >
                {item.key === "tender" && item.key === activeTap
                  ? ordersTotal
                  : orderCounts[item.key] || 0}
              </span>
            </button>
          ))}
          <div className={style.menu_tools}>
            <div className={cn(style.filterBtn, { [style.filterBtn_active]: isFilterOpen })}>
              <button
                type="button"
                className={style.innerBtn}
                onClick={() => setFilterOpen((prev) => !prev)}
                title={t("orderFilter.title")}
              >
                <FilterIcon />
                {t("orderFilter.title")}
              </button>

              {hasActiveFilters && (
                <button
                  type="button"
                  className={cn(style.innerBtn, style.resetBtn)}
                  onClick={handleReset}
                  title={t("orderFilter.resetButton")}
                >
                  <XIcon size={20} />
                </button>
              )}
            </div>
            <ExportAviationOrders onDownloadExcel={handleDownloadExcel} isLoading={isExportLoading} />
          </div>
        </div>

        {/* Мобильный Dropdown */}
        <div ref={dropdownRef} className={style.dropdownWrapper}>
          <div className={style.flex}>
            <button
              type="button"
              className={cn(style.button, 'd-flex align-items-center', {
                [style.button_active]: activeStatus?.key === activeTap,
              })}
              onClick={toggleDropdown}
            >
              {activeStatus?.title}
              <span className={style.count}>
                {activeStatus?.quantity || 0}
              </span>
              <div className={style.imgSelect}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  className={style.checkmark}
                >
                  <path
                    d="M1 1.5L5 5.5L9 1.5"
                    stroke="#909195"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </button>
            {/* Mobile export button */}
            <div className={style.mobileTools}>
              <div className={cn(style.filterBtn, { [style.filterBtn_active]: isFilterOpen })}>
                <button
                  type="button"
                  className={style.innerBtn}
                  onClick={() => setFilterOpen((prev) => !prev)}
                  title={t("orderFilter.title")}
                >
                  <FilterIcon />
                  {t("orderFilter.title")}
                </button>

                {hasActiveFilters && (
                  <button
                    type="button"
                    className={cn(style.innerBtn, style.resetBtn)}
                    onClick={handleReset}
                    title={t("orderFilter.resetButton")}
                  >
                    <XIcon size={20} />
                  </button>
                )}
              </div>
              <ExportAviationOrders onDownloadExcel={handleDownloadExcel} isLoading={isExportLoading} />
            </div>
          </div>

          {isDropdownOpen && (
            <div className={style.dropdownContent}>
              {items.map((item) => (
                <button
                  type="button"
                  key={"dropdown-" + item.key}
                  className={cn(style.button, 'd-flex align-items-center', {
                    [style.button_none]: item.key === activeStatus?.key,
                  })}
                  onClick={() => {
                    toggleDropdown();
                    updateActiveStatus(item, item.status);
                  }}
                >
                  {item.title}
                  <span className={style.count}>
                    {item.quantity}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>

        <OrdersContent>
          <BulkSelectionBar
            selectedCount={selectedCount}
            totalCount={ordersTotal}
            onSelectAll={handleSelectAllOrders}
            onClear={resetSelection}
            selectedOrders={selectedOrdersForCancellation}
            isAirOrder
            isSelectAllMode={selectionMode === "all"}
            onCancelSuccess={() => {
              resetSelection();
              triggerForceUpdate();
            }}
          />

          <div className={style.content}>
            {isLoading ? (
              <Loading inBlock />
            ) : isExportLoading ? (
              <div className={style.exportLoading}>
                <Loading inBlock />
                <p>{t('ordersListPage.exportLoading')}</p>
              </div>
            ) : (
              <>
                {!orders.length ? <EmptyContent /> : null}
                <OrdersAviationTable
                  items={orders || []}
                  showTable={orders.length > 0}
                  isLoading={false}
                  companyName={user?.companyName}
                  isExpeditor={user?.type === "Expeditor"}
                  notificationsMap={notificationsMap}
                  onForceUpdate={triggerForceUpdate}
                  selectedIds={selectedIds}
                  setSelectedIds={setSelectedIds}
                  unselectedIds={unselectedIds}
                  setUnselectedIds={setUnselectedIds}
                  selectionMode={selectionMode}
                />

                {orders.length > 0 ? (
                  <OrdersAviationTableMobile
                    items={orders || []}
                    isLoading={false}
                    companyName={user?.companyName}
                    isExpeditor={user?.type === "Expeditor"}
                    notificationsMap={notificationsMap}
                    onForceUpdate={triggerForceUpdate}
                  />
                ) : null}
              </>
            )}
          </div>

          <DefaultPaginationNew
            currentPage={currentPage}
            limit={limit}
            total={ordersTotal}
            changePage={setCurrentPage}
            changeLimit={handleChangeLimit}
            isLoading={isLoading}
          />
        </OrdersContent>
      </WrapperOrders>

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
    </>
  );
};

export default ListsAviationPage;
